import React, { createContext, useCallback, useContext } from 'react';

/**
 * WHAT THIS COMPETITION CALLS ITS TWO CORNERS — FSKA АКА/ШІРО, MSAC ЧЕР/БІЛ,
 * or the organiser's override (25 Oct 2026: «в налаштуваннях білий, червоний,
 * а в поєдинках АКА — SHIRO»). The backend resolves the words (the
 * competition's `cornerNames`, the workspace's `akaCornerName` /
 * `shiroCornerName`); a screen provides them once and every corner label
 * under it — the bracket's badges, the fight protocol, the mat's panel —
 * reads them here. Without a provider: the locale's АКА / ШІРО, as before.
 */
const CornerNamesContext = createContext(null);

export const CornerNamesProvider = ({ names, children }) => (
    <CornerNamesContext.Provider value={names && names.aka && names.shiro ? names : null}>
        {children}
    </CornerNamesContext.Provider>
);

/**
 * side ('aka' | 'shiro', any case) → the word to print. `fallback` answers
 * when no competition named its corners — by default the side itself
 * (AKA / SHIRO, the design system's untranslated term).
 */
export const useCornerName = (fallback = null) => {
    const names = useContext(CornerNamesContext);

    return useCallback(side => {
        const key = String(side || '').toLowerCase();
        if (names && names[key]) {
            return names[key];
        }

        return fallback ? fallback(key) : key.toUpperCase();
    }, [names, fallback]);
};
